<script setup lang="ts">
import BaseTitle from '@/js/account/components/base/BaseTitle.vue';
import { classNames } from '@/js/lib/bem';

defineProps<{
  title: string
}>();

const cn = classNames('auth-title');
</script>

<template>
  <div :class="cn()">
    <BaseTitle size="lg" :class="cn('title')">
      {{ title }}
    </BaseTitle>
    <div v-if="$slots.description" :class="cn('description')">
      <slot name="description" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.auth-title {
  margin-bottom: 32px;

  &__title {
    margin: 0 0 38px;
  }
}
</style>
